import jhsfBookingsApi from '../apis/jhsfBookingsApi';

export const deleteVentureExperienceLevelsService = async (
  experienceLevelId: string,
): Promise<void> => {
  await jhsfBookingsApi.delete(
    `/ventures/experience-levels/${experienceLevelId}`,
  );
};
